export default __webpack_public_path__ + "static/launch-partner_divinedao_left@2x-1ed40f655c41205149c6262b4250befa.jpg";